import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component, useEffect, useState }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import Moment from "moment";
import Select from "react-select";
import NumericInput from 'react-numeric-input';
import { Autocomplete } from '@mui/material';
import { TextField } from '@material-ui/core';
import { Spinner } from 'reactstrap';
import { de } from 'date-fns/locale';
import { apiFetch, API, getMarket } from "../../services/api";

function AddCoinsModalV2({isOpen, closeModal}) {
    const [selectedUser, setSelectedUser] = useState(null)
    const [searchedUsers, setSearchededUsers] = useState([])
    const [searchedData, setSearchedData] = useState(null)
    const [loadingData, setLoadingData] = useState(false)
    const [containsData, setContainsData] = useState(false)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [selectedCoin, setSelectedCoin] = useState(null)
    const [name, setName] = useState(null)
    const [description, setDescription] = useState(null)

    const onTagsChange = (values) => {
        if (values){
            setLoadingData(true);
            fetch('https://back-api.therunningcollective.fr/searched-front-users?searched_data=' + values, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then(response => { return response.json(); })
            .then(responseData => {return responseData;})
            .then(data => {console.log(data); setSearchededUsers(data); setLoadingData(false); setContainsData(true)})
            .catch( err =>
                console.log(err)
            );
        }
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            onTagsChange(searchedData)
        }, 2000)

        return () => clearTimeout(delayDebounceFn)

    }, [searchedData])

    const handleClose = (selectedUser) => {
        setLoadingSubmit(true)
        let coin = {
            name: name,
            description: description,
            user: selectedUser,
            count: selectedCoin,
            language: getMarket()
        }
        return apiFetch(API.back + '/coin', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(coin)
        }).then(() => {
            setLoadingSubmit(false);
            window.location.reload();
        })
        .catch( err =>
            setLoadingSubmit(false)
        )
    }


    return(
        <Modal
            show={isOpen}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un ambassadeur</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <Form.Group >
                                        <Form.Group >
                                            <Form.Label>Rechercher un utilisateur : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => setSearchedData(e.target.value)} placeholder="antoine"/>
                                        </Form.Group>
                                    </Form.Group>
                                    {
                                        loadingData ?
                                        <Row style={{marginTop: "30px", textAlign:"center"}}>
                                            <Col>
                                                <div style={{textAlign: 'center'}}>
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden"></span>
                                                    </Spinner>
                                                </div>
                                            </Col>
                                        </Row>
                                        : containsData ?
                                        <>
                                            <Form.Group>
                                                <Form.Label>Liste des utilisateurs trouvés :</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    custom
                                                    onChange={(e) => {
                                                    const email = e.target.value;
                                                    const selected = searchedUsers.find(u => u.email === email);
                                                    setSelectedUser(selected || null);
                                                    }}
                                                >
                                                    <option value="">Ajouter...</option>

                                                    {searchedUsers?.map(user => (
                                                    <option key={user.email} value={user.email}>
                                                        {user.firstName} {user.name} ({user.email})
                                                    </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>

                                            <Form.Group >
                                                <Form.Label>Nom : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setName(e.target.value)} defaultValue={name} placeholder="Ajout de 100 TRCoins"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Description : </Form.Label>
                                                <Form.Control as="textarea" rows={4} onChange={(e) => {description = setDescription(e.target.value)}} defaultValue={description} placeholder="Pour avoir réalisé cette action"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Nombre de TRCoins : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => setSelectedCoin(parseInt(e.target.value,10))} defaultValue={selectedCoin} placeholder="100"/>
                                            </Form.Group>
                                        </>                                 
                                        : null
                                    }
                                    
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
            <Modal.Footer>
                {
                    loadingSubmit ?
                    <Row style={{textAlign:"center"}}>
                        <Col>
                            <div style={{textAlign: 'center'}}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden"></span>
                                </Spinner>
                            </div>
                        </Col>
                    </Row>
                    :
                    <>
                        <Button variant="secondary" type="cancel" onClick={closeModal}>
                            Annuler
                        </Button>
                        {
                            selectedUser ?
                                <Button variant="primary" type="submit" onClick={() => handleClose(selectedUser)}>
                                    Valider
                                </Button>
                                : <Button variant="primary" type="submit" disabled>
                                    Valider
                                </Button>

                        }
                    </>
                
            }
                
            </Modal.Footer>
        </Modal>
    )
}

export default AddCoinsModalV2;

export function sliceIntoChunks(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}